import type { ReservationRequestStatus } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_REQUEST_LIST_BY_C_IN_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY } from "../schema";

type Props = {
	queryVariables?: {
		hotelID: string;
		from: string;
		to: string;
		reservationRequestStatus: ReservationRequestStatus;
	};
};

export const useReservationRequestListByCInDateQuery = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_REQUEST_LIST_BY_C_IN_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_REQUEST_QUERY,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	const { onConvertQueryData } = Converter.useReservationListByCInDateQueryData();
	const { queryData } = onConvertQueryData({ serverData: data });

	return {
		queryData,
	};
};
